export default __webpack_public_path__ + "static/media/pokebola.dc18ea15.gif";